// AIDEV-NOTE: Utilitario para fallback offline — tenta Supabase primeiro, usa Dexie se rede falhar

/**
 * Identifica erros de conectividade de rede
 */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof TypeError) {
    return error.message.includes('Failed to fetch') || error.message.includes('NetworkError');
  }
  if (error instanceof Error) {
    return error.message.includes('Network Error') || error.message.includes('net::ERR_');
  }
  return false;
}

/**
 * Executa query no Supabase com fallback para Dexie em caso de falha de rede.
 * Erros nao relacionados a rede sao re-lancados normalmente.
 *
 * @param supabaseFn - Query principal (Supabase)
 * @param dexieFn - Fallback offline (Dexie IndexedDB)
 * @returns Dados do Supabase ou do Dexie
 */
export async function withOfflineFallback<T>(
  supabaseFn: () => Promise<T>,
  dexieFn: () => Promise<T>
): Promise<T> {
  try {
    return await supabaseFn();
  } catch (error) {
    if (isNetworkError(error)) {
      console.warn('[offline] Supabase unreachable, using Dexie fallback');
      return await dexieFn();
    }
    throw error;
  }
}
